<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true">
      Content Edit
    </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">
        Content preview
      </div>
      <div class="text-left content-preview" v-html="node.content">
      </div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <div class="message-item__label">
      {{ $t("shortcodes.live_chat_auto.answer_preview") }}
    </div>
    <img class="w-full" :src="currentImage" />
  </div>
</template>

<script>
  import questionPreviewAgeGroup from "@/assets/images/svg/default-question-age-group-img.svg";

  export default {
    name: "LiveChatDefaultQuestion",
    components: {},
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentImage: "",
        showEditor: !this.node?.content,
      };
    },
    computed: {},
    mounted() {
      const questionPreviewImages = {
        age_group: questionPreviewAgeGroup,
      };

      this.currentImage = questionPreviewImages[this.node.defaultQuestionType] || null;
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateMessageContent(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .message-item {
    &__label {
      color: get-color("subtitle");
      @include text-caption-bold();
      width: 100%;
      text-align: left;
      margin-bottom: 6px;
    }
  }
</style>
